const SET_GALLERY_PROFILE_CONTENT = 'SET_GALLERY_PROFILE_CONTENT';

export { SET_GALLERY_PROFILE_CONTENT };
